/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import background from '../../../../assets/images/about_page_header_map.svg';

const createHeaderSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '100vh',
      backgroundImage: `url('${background}')`,
      backgroundPosition: 'bottom right',
      backgroundRepeat: 'no-repeat',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 calc(100% * (150 / 1440)) calc(100% * (112 / 1440))',
    },
    container: {
      maxWidth: '1140px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    logo: {
      marginTop: '45px',
    },
    imageLogo: {
      width: 'auto',
      height: '42px',
      maxWidth: '162px',
      maxHeight: '100%',
    },
    h1: {
      marginBottom: '67px',
    },
    h2: {
      marginBottom: '40px',
    },
    location: {
      marginBottom: '40px',
      fontSize: '24px',
      fontWeight: 500,
      letterSpacing: '-0.18px',
      lineHeight: '30px',

      '& > strong': {
        color: theme.palette.secondary.main,
        fontWeight: 500,
      },

      '&:before': {
        content: "'\\1F4CD'",
        paddingRight: '6px',
      },
    },
    body2: {
      fontSize: '20px',
    },
  }),
);
export { createHeaderSectionStyles };
